'use strict';

import React from 'react';
import { useDispatch } from 'react-redux';
import { TrackingConstants, fetchUpdatedFilterState } from '../cfs-search-slice';

import analytics from '../../../../utils/analytics';

const classNames = {
	searchFilterContent: 'search-filter-content',
	filterOption: 'list__option',
	filterOptionLabel: 'list__option__label'
};

let ListExcerpt = ({ filterItems, heading, onItemSelected }) => {
	if (!filterItems || filterItems.length === 0) {
		return null;
	}

	const links = filterItems.map(function (item) {
		return (
			<li key={item.value} className="search-filter-content__list__item">
				<a className="search-filter-content__list__option" value={item.value} onClick={onItemSelected}>
					<span className="search-filter-content__list__option__label">{item.displayText}</span>
					<span className="search-filter-content__list__option__count">({item.count.toLocaleString('en-GB')})</span>
				</a>
			</li>
		);
	});

	return (
		<div className="search-filter-content__list">
			<h3 className="search-filter-content__list__heading">{heading}</h3>
			<ul className="search-filter-content__list__items">
				{links}
			</ul>
		</div>
	);
};
ListExcerpt = React.memo(ListExcerpt);

export const ListFilter = ({ filterItems, popularValues, filterName, label, popularLabel }) => {
	const dispatch = useDispatch();

	const onItemSelected = (e) => {
		const $filterOption = $(e.target).closestByBem(classNames.searchFilterContent, classNames.filterOption);

		const $label = $filterOption.findByBem(classNames.searchFilterContent, classNames.filterOptionLabel);
		analytics.trackEvent(TrackingConstants.Categories.Added, filterName, $label.text());

		const value = $filterOption.attr('value') ?? '';
		dispatch(fetchUpdatedFilterState({
			name: filterName,
			value: value
		}));
	};

	let popularItems;
	if (popularValues) {
		popularItems = $.grep(filterItems, (item) => popularValues.indexOf(item.value) !== -1);
	}

	return (
		<>
			<ListExcerpt filterItems={popularItems} heading={popularLabel} onItemSelected={onItemSelected} />
			<ListExcerpt filterItems={filterItems} heading={label} onItemSelected={onItemSelected} />
		</>
	);
}